export default __webpack_public_path__ + "static/media/Loader.1c815c3e.png";